module.exports = __webpack_public_path__ + "static/media/image-2.5dc29277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-54/image-2.jpg
// module id = 271
// module chunks = 0